import React, { useState, useEffect } from 'react';
import './AddEventPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const GCP_PRD_API_URL = process.env.PRD_API_URL;

// Event descriptions mapping
const EVENT_DESCRIPTIONS = {
  "edsas01": "Attended grade 1 in school",
  "edsas08": "Attend grade 8 in school",
  "edsas12": "Attend grade 12 in school",
  "edhafdu": "Attend full-time, degree unknown",
  "edhefdu": "Enroll in full-time education",
  "edhemsd": "Enroll with masters degree",
  "edhebsa": "Enroll with a BA or BSc",
  "edhebeg": "Enroll with a BE",
  "edhebba": "Enroll with a Bachelor of Business",
  "edhephd": "Enroll with a PhD",
  "edheedu": "Enroll with a degree",
  "edhepro": "Enroll with a Professional degree",
  "edhgmsd": "Graduate with Masters degree",
  "edhgbsa": "Graduate with a BA or BSc",
  "edhgbeg": "Graduate with a Bachelor Eng",
  "edhgbba": "Graduate with a Bachelor of Business",
  "edhgphd": "Graduate with a doctoral degree, phd",
  "edhgedu": "Graduate with a degree",
  "edhgpro": "Graduate with a professional degree",
  "crrsjnj": "Start a new job",
  "crrprjb": "Promotion in job",
  "crrlqjb": "Change job",
  "crrrtjb": "Retire from job",
  "prsbapr": "Buy an apartment or a house",
  "prssafp": "Buy an apartment or a house with partner",
  "socpwfd": "Go on a date with someone",
  "socpmrr": "Get married",
  "socpdvd": "Get a divorce",
  "socbprg": "Get pregnant",
  "socbbpr": "Your partner get pregnant",
  "socnb01": "A New born first child",
  "hthchgn": "Might have a chronic health condition",
  "hthchiv": "Beware of HIV/aids",
  "hthcstd": "Get an STD",
  "hthcanm": "Get anemia",
  "hthcazm": "Get asthma",
  "hthccnr": "Get cancer",
  "hthcdbt": "Get diabetes",
  "hthcepl": "Get epilepsy",
  "hthchrt": "Get heart condition",
  "prslrfc": "Relocate to another country",
  "prslctr": "Relocate within Country",
  "prslstt": "Relocate within State",
  "prslctn": "Relocate within the county"
};

// Event vocabulary
const EVENT_VOCABULARY = [
  {
    category: "EDUCATION",
    events: [
      { code: "edsas01", label: "Attended grade 1 in school" },
      { code: "edsas08", label: "Attend grade 8 in school" },
      { code: "edsas12", label: "Attend grade 12 in school" },
      { code: "edhebba", label: "Enroll in BBA" },
      { code: "edhgbba", label: "Graduated BBA" },
      { code: "edhebeg", label: "Enrolled in B.E." },
      { code: "edhgbeg", label: "Graduated B.E." },
      { code: "edhebsa", label: "Enroll in BA/BSc" },
      { code: "edhgbsa", label: "Graduate BA/BSc" },
      { code: "edhemsd", label: "Enroll in Masters" },
      { code: "edhgmsd", label: "Graduate Masters" },
      { code: "edhephd", label: "Enroll in PhD" },
      { code: "edhgphd", label: "Graduate PhD" },
      { code: "edhepro", label: "Enroll Professional Degree" },
      { code: "edhgpro", label: "Graduate Professional Degree" },
      { code: "edheedu", label: "Enroll in Degree" },
      { code: "edhgedu", label: "Graduate with Degree" }
    ]
  },
  {
    category: "CAREER",
    events: [
      { code: "crrsjnj", label: "Start a new job" },
      { code: "crrprjb", label: "Promotion in job" },
      { code: "crrlqjb", label: "Change job" },
      { code: "crrrtjb", label: "Retire from job" }
    ]
  },
  {
    category: "FAMILY",
    events: [
      { code: "socpwfd", label: "Go on a date with someone" },
      { code: "socpmrr", label: "Get married" },
      { code: "socpdvd", label: "Get a divorce" },
      { code: "socbprg", label: "Get pregnant" },
      { code: "socbbpr", label: "Your partner get pregnant" },
      { code: "socnb01", label: "A New born first child" }
    ]
  },
  {
    category: "HEALTH",
    events: [
      { code: "hthchgn", label: "Might have a chronic health condition" },
      { code: "hthchiv", label: "Beware of HIV/aids" },
      { code: "hthcstd", label: "Get an STD" },
      { code: "hthcanm", label: "Get anemia" },
      { code: "hthcazm", label: "Get asthma" },
      { code: "hthccnr", label: "Get cancer" },
      { code: "hthcdbt", label: "Get diabetes" },
      { code: "hthcepl", label: "Get epilepsy" },
      { code: "hthchrt", label: "Get heart condition" }
    ]
  },
  {
    category: "LOCATION",
    events: [
      { code: "prsbapr", label: "Buy an apartment or a house" },
      { code: "prssafp", label: "Buy an apartment or a house with partner" },
      { code: "prslrfc", label: "Relocate to another country" },
      { code: "prslctr", label: "Relocate within Country" },
      { code: "prslstt", label: "Relocate within State" },
      { code: "prslctn", label: "Relocate within the county" }
    ]
  }
];

const AdSensePlaceholder = () => (
  <div className="adsense-placeholder">
    <div className="ad-content">
      <span className="ad-label">Advertisement</span>
      <p className="ad-text">AdSense Ad</p>
    </div>
  </div>
);

const PredictionModal = ({ prediction, onClose, isFree }) => {
  const getEventDescription = (eventCode) => {
    return EVENT_DESCRIPTIONS[eventCode] || eventCode;
  };

  return (
    <div className="prediction-modal-overlay" onClick={onClose}>
      <div className="prediction-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>✕</button>
        
        <div className="modal-grid">
          {/* Main Prediction */}
          <div className="modal-main">
            <h2 className="modal-title">
              <span className="modal-icon">🔮</span>
              Your Prediction
            </h2>
            
            <div className="modal-prediction">
              <div className="top-prediction-box">
                <div className="prediction-label">Most Likely Next Event:</div>
                <h3 className="top-prediction-event">
                  {getEventDescription(prediction.top_prediction.event)}
                </h3>
                <div className="confidence-display">
                  <span className="confidence-label">Confidence:</span>
                  <span className="confidence-value">
                    {(prediction.top_prediction.probability * 100).toFixed(2)}%
                  </span>
                </div>
                <div className="time-estimate">
                  <span className="time-label">Estimated Time:</span>
                  <span className="time-value">
                    {prediction.estimated_time.years > 0 
                      ? `${prediction.estimated_time.years} Year${prediction.estimated_time.years > 1 ? 's' : ''} and ${prediction.estimated_time.months.toFixed(1)} Months`
                      : prediction.estimated_time.months < 1
                        ? 'Soon (Less than a month!)'
                        : `${prediction.estimated_time.months.toFixed(1)} Months`
                    }
                  </span>
                </div>
              </div>

              <div className="other-predictions">
                <h4 className="other-title">Other Possibilities:</h4>
                <ul className="prediction-list">
                  {prediction.top_events.map((item, index) => (
                    <li key={index} className="prediction-item">
                      <span className="event-name">
                        {getEventDescription(item.event)}
                      </span>
                      <span className="event-probability">
                        {(item.probability * 100).toFixed(2)}%
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* AdSense Sidebar for Free Tier */}
          {isFree && (
            <div className="modal-sidebar">
              <AdSensePlaceholder />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const AddEventPage = ({ user, token, onUpdate, onUpgradeClick }) => {
  const [selectedPersona, setSelectedPersona] = useState('self');
  const [personas, setPersonas] = useState([]);
  const [eventCode, setEventCode] = useState('');
  const [dateOfEvent, setDateOfEvent] = useState('');
  const [eventSequences, setEventSequences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showPrediction, setShowPrediction] = useState(false);
  const [prediction, setPrediction] = useState(null);
  const [predictLoading, setPredictLoading] = useState(false);

  const isFree = user.tier === 'free';
  
  // Get tier limits
  const tierLimits = {
    free: 4,
    paid: 6,
    premium: 8
  };
  
  const predictionLimits = {
    free: 5,
    paid: 15,
    premium: 25
  };
  
  const maxEvents = tierLimits[user.tier];
  const maxPredictions = predictionLimits[user.tier];
  const remainingPredictions = maxPredictions - (user.dailyPredictionCount || 0);
  const isLimitReached = eventSequences.length >= maxEvents;

  useEffect(() => {
    fetchPersonas();
  }, []);

  useEffect(() => {
    // Fetch events whenever selectedPersona changes
    console.log('Persona changed to:', selectedPersona);
    fetchEventSequences(selectedPersona);
  }, [selectedPersona]);

  const fetchPersonas = async () => {
    try {
      const response = await fetch(`${API_URL}/personas`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setPersonas(data);
        console.log('Personas loaded:', data);
      }
    } catch (err) {
      console.error('Error fetching personas:', err);
    }
  };

  const fetchEventSequences = async (personaId) => {
    console.log('Fetching events for persona:', personaId);
    setLoadingEvents(true);
    
    try {
      // Build URL with persona_id query parameter          //api/user/events/:personaId
      //p => p.id === req.params.personaId
//      const url = `${API_URL}/user/events?persona_id=${encodeURIComponent(personaId)}`;

      //const url = `${API_URL}/user/events/?persona_id=${encodeURIComponent(personaId)}`;
      const url = `${API_URL}/user/events/${encodeURIComponent(personaId)}`;
      console.log('Fetching from URL:', url);
      
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('Events received:', data);
        console.log('Events details:', data.map(e => ({ 
          event_id: e.event_id.substring(0, 8), 
          persona_id: personaId,
          event_code: e.event_code,
          date: e.date_of_event 
        })));
        
        // Sort by date (oldest to newest)
        const sorted = data.sort((a, b) => new Date(a.date_of_event) - new Date(b.date_of_event));
        setEventSequences(sorted);
        console.log('Events sorted and set:', sorted.length, 'events');
      } else {
        console.error('Failed to fetch events:', response.status);
        setEventSequences([]);
      }
    } catch (err) {
      console.error('Error fetching sequences:', err);
      setEventSequences([]);
    } finally {
      setLoadingEvents(false);
    }
  };

  const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!eventCode || !dateOfEvent) {
      setError('Please fill in all required fields');
      return;
    }

    if (isLimitReached) {
      setError(`You've reached the limit of ${maxEvents} events for your tier`);
      if (onUpgradeClick) onUpgradeClick();
      return;
    }

    setLoading(true);

    try {
      const eventId = generateUUID();
      
      console.log('Adding event for persona:', selectedPersona);
      
      const eventData = {
        event_id: eventId,
        user_id: user.id, // Always use actual user ID for authorization
        user_email: user.email,
        persona_id: selectedPersona, // This determines which persona the event belongs to
        event_code: eventCode,
        date_of_event: dateOfEvent,
        created_at: new Date().toISOString()
      };
      
      console.log('Event data being sent:', eventData);


      const response = await fetch(`${API_URL}/user/events`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(eventData)
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Event saved, response:', result);
        setMessage('Event added successfully! ✨');
        setEventCode('');
        setDateOfEvent('');
        fetchEventSequences(selectedPersona);
        if (onUpdate) onUpdate();
        setTimeout(() => setMessage(''), 3000);
      } else {
        const data = await response.json();
        setError(data.error || 'Failed to add event');
      }
    } catch (err) {
      setError('Network error. Please try again.');
      console.error('Add event error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteEvent = async (eventId) => {
    if (!window.confirm('Are you sure you want to delete this event?')) {
      return;
    }

    try {
      const response = await fetch(`${API_URL}/user/events/${eventId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        setMessage('Event deleted successfully');
        fetchEventSequences(selectedPersona);
        setTimeout(() => setMessage(''), 3000);
      } else {
        setError('Failed to delete event');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }
  };

  const handlePredict = async () => {
    if (eventSequences.length < 2) {
      setError('You need at least 2 events to make a prediction');
      return;
    }

    // Check prediction limits
    const predictionLimits = {
      free: 5,
      paid: 15,
      premium: 25
    };
    
    const maxPredictions = predictionLimits[user.tier];
    const remainingPredictions = maxPredictions - (user.dailyPredictionCount || 0);
    
    if (remainingPredictions <= 0) {
      setError('Daily prediction limit reached. Please upgrade or try again tomorrow!');
      if (onUpgradeClick) onUpgradeClick();
      return;
    }

    setPredictLoading(true);
    setError('');

    try {
      const eventCodes = eventSequences.map(e => e.event_code);
      
      // Call prediction API
//      const predictionResponse = await fetch('http://127.0.0.1:5000/predict', {
//      const predictionResponse = await fetch('http://192.168.1.32:5000/predict', {

//        const predictionResponse = await fetch('${GCP_PRD_API_URL}/predict', {
        const predictionResponse = await fetch('https://prediction-api-302792922407.us-central1.run.app/predict', {


        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_sequence: eventCodes })
      });

      const predictionData = await predictionResponse.json();

      if (predictionData.status === 'success') {
        // Update prediction count in backend
        await fetch(`${API_URL}/predict`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            personaId: selectedPersona,
            sequenceEvents: eventCodes
          })
        });
        
        setPrediction(predictionData.prediction_summary);
        setShowPrediction(true);
        
        // Refresh user data to update prediction count
        if (onUpdate) onUpdate();
      } else {
        setError('Prediction failed');
      }
    } catch (err) {
      setError('Prediction API not available');
      console.error('Prediction error:', err);
    } finally {
      setPredictLoading(false);
    }
  };

  const getEventLabel = (code) => {
    return EVENT_DESCRIPTIONS[code] || code;
  };

  return (
    <div className="add-event-page">
      <div className="cosmic-bg"></div>
      
      <div className="page-header">
        <h1 className="page-title">➕ Add Life Events</h1>
        <p className="page-subtitle">Build your event timeline for accurate predictions</p>
      </div>

      <div className="add-event-content">
        <div className="add-event-main">
          {/* Persona Selector */}
          <div className="card persona-select-card">
            <label className="input-label">
              <span className="label-icon">👤</span>
              Select Persona
            </label>
            <select
              className="persona-select-input"
              value={selectedPersona}
              onChange={(e) => setSelectedPersona(e.target.value)}
            >
              <option value="self">Myself</option>
              {personas.map(persona => (
                <option key={persona.id} value={persona.id}>
                  {persona.name}
                </option>
              ))}
            </select>
          </div>

          {/* Add New Event Form */}
          <div className="card add-event-card">
            <div className="card-header">
              <h2 className="card-title">
                <span className="title-icon">📅</span>
                Add New Event
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="event-form">
              <div className="form-section">
                <div className="input-group">
                  <label className="input-label">
                    <span className="label-icon">🔖</span>
                    Event Type *
                  </label>
                  <select
                    className="event-select"
                    value={eventCode}
                    onChange={(e) => setEventCode(e.target.value)}
                    required
                  >
                    <option value="">-- Select an event --</option>
                    {EVENT_VOCABULARY.map(category => (
                      <optgroup key={category.category} label={category.category}>
                        {category.events.map(evt => (
                          <option key={evt.code} value={evt.code}>
                            {evt.label}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </div>

                <div className="input-group">
                  <label className="input-label">
                    <span className="label-icon">📆</span>
                    Date of Event *
                  </label>
                  <input
                    type="date"
                    className="event-input"
                    value={dateOfEvent}
                    onChange={(e) => setDateOfEvent(e.target.value)}
                    max={new Date().toISOString().split('T')[0]}
                    required
                  />
                </div>
              </div>

              {message && (
                <div className="success-message">
                  <span className="success-icon">✓</span>
                  {message}
                </div>
              )}

              {error && (
                <div className="error-message">
                  <span className="error-icon">⚠️</span>
                  {error}
                </div>
              )}

              {isLimitReached ? (
                <button 
                  type="button"
                  className="upgrade-limit-btn"
                  onClick={onUpgradeClick}
                >
                  <span className="btn-icon">🔒</span>
                  <span>Upgrade to Add More Events ({eventSequences.length}/{maxEvents})</span>
                </button>
              ) : (
                <button 
                  type="submit" 
                  className="add-event-btn"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-small"></span>
                      <span>Adding...</span>
                    </>
                  ) : (
                    <>
                      <span className="btn-icon">➕</span>
                      <span>Add Event ({eventSequences.length}/{maxEvents})</span>
                    </>
                  )}
                </button>
              )}
            </form>
          </div>

          {/* Event Sequence List */}
          <div className="card sequence-list-card">
            <div className="sequence-header">
              <h2 className="card-title">
                <span className="title-icon">📋</span>
                Event Timeline ({eventSequences.length})
              </h2>
              <div className="prediction-counter">
                <span className="counter-icon">🔮</span>
                <span>{remainingPredictions} predictions remaining today</span>
              </div>
            </div>

            {eventSequences.length === 0 ? (
              <div className="empty-state">
                {loadingEvents ? (
                  <>
                    <span className="spinner-large"></span>
                    <p>Loading events...</p>
                  </>
                ) : (
                  <>
                    <span className="empty-icon">📭</span>
                    <p>No events added yet. Add your first event above!</p>
                  </>
                )}
              </div>
            ) : (
              <>
                {loadingEvents ? (
                  <div className="loading-overlay">
                    <span className="spinner-large"></span>
                    <p>Loading events...</p>
                  </div>
                ) : (
                  <div className="sequence-list">
                    {eventSequences.map((event, index) => (
                      <div key={event.event_id} className="sequence-item">
                        <div className="sequence-number">{index + 1}</div>
                        <div className="sequence-info">
                          <div className="sequence-event">{getEventLabel(event.event_code)}</div>
                          <div className="sequence-meta">
                            <span className="sequence-code">{event.event_code}</span>
                            <span className="sequence-date">📅 {event.date_of_event}</span>
                          </div>
                        </div>
                        <button
                          className="delete-event-btn"
                          onClick={() => handleDeleteEvent(event.event_id)}
                          title="Delete event"
                        >
                          🗑️
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <button
                  className="predict-sequence-btn"
                  onClick={handlePredict}
                  disabled={predictLoading || eventSequences.length < 2 || loadingEvents}
                >
                  {predictLoading ? (
                    <>
                      <span className="spinner-small"></span>
                      <span>Predicting...</span>
                    </>
                  ) : (
                    <>
                      <span className="predict-icon">🔮</span>
                      <span>Predict Next Event</span>
                    </>
                  )}
                </button>
              </>
            )}
          </div>
        </div>

        {/* AdSense for Free Tier */}
        {isFree && (
          <div className="add-event-sidebar">
            <AdSensePlaceholder />
          </div>
        )}
      </div>

      {/* Prediction Modal */}
      {showPrediction && prediction && (
        <PredictionModal
          prediction={prediction}
          onClose={() => setShowPrediction(false)}
          isFree={isFree}
        />
      )}
    </div>
  );
};

export default AddEventPage;